// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avn9d50 {\n  cursor: pointer;\n  object-fit: cover;\n  display: block;\n}\n.avn9d51 {\n  object-fit: cover;\n}", ""]);
// Exports
module.exports = exports;
